import React from 'react';
import { ArrowRight } from 'lucide-react';
import getIcon from '../utils/iconMap';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import SignUpLink from './SignUpLink';

export default function Services({ cms }) {
  const { t } = useI18n();
  const { services: fallbackServices } = useBookersContent();
  const s = cms || {};
  const eyebrow = s.eyebrow || t('services.eyebrow');
  const title = s.title || t('services.title');
  const description = s.description || t('services.description');
  const items = s.items || fallbackServices;

  return (
    <section id="services" className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
      <div className="text-center max-w-2xl mx-auto reveal">
        <p className="text-sm font-semibold text-[#76B828]">{eyebrow}</p>
        <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{title}</h2>
        <p className="text-[#55555f] mt-4 text-lg">{description}</p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {items.map((item, i) => {
          const Icon = typeof item.icon === 'string' ? getIcon(item.icon) : item.icon;
          return (
            <div key={item.key || i} className="card-soft reveal overflow-hidden" style={{ transitionDelay: `${i * 90}ms` }}>
              <div className="h-52 overflow-hidden">
                <img src={item.image} alt={item.title} className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <span className="h-11 w-11 rounded-xl bg-[#EEF6DC] flex items-center justify-center">
                  <Icon size={22} className="text-[#76B828]" />
                </span>
                <h3 className="font-display text-xl mt-4 text-[#0b0b0f]">{item.title}</h3>
                <p className="text-[#6b6b73] mt-2 leading-relaxed text-[15px]">{item.desc}</p>
                <SignUpLink className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0b0b0f] hover:gap-3 transition-all">
                  {t('services.getStarted')} <ArrowRight size={16} />
                </SignUpLink>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
